import { onUnmounted, watch, type Ref } from 'vue';

const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
const LOCKED_VIEWPORT =
  'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover';

function blockGesture(event: Event) {
  event.preventDefault();
}

export function usePreventPageZoom(enabled: Ref<boolean>) {
  const meta = document.querySelector('meta[name="viewport"]');
  const previousContent = meta?.getAttribute('content') ?? DEFAULT_VIEWPORT;
  let locked = false;

  function lock() {
    if (locked || !meta) return;
    meta.setAttribute('content', LOCKED_VIEWPORT);
    document.addEventListener('gesturestart', blockGesture, { passive: false });
    document.addEventListener('gesturechange', blockGesture, { passive: false });
    document.addEventListener('gestureend', blockGesture, { passive: false });
    document.documentElement.classList.add('prevent-page-zoom');
    locked = true;
  }

  function unlock() {
    if (!locked || !meta) return;
    meta.setAttribute('content', previousContent);
    document.removeEventListener('gesturestart', blockGesture);
    document.removeEventListener('gesturechange', blockGesture);
    document.removeEventListener('gestureend', blockGesture);
    document.documentElement.classList.remove('prevent-page-zoom');
    locked = false;
  }

  watch(
    enabled,
    (value) => {
      if (value) lock();
      else unlock();
    },
    { immediate: true },
  );

  onUnmounted(unlock);
}
